export default __webpack_public_path__ + "static/media/meeting-with-purpose.724e2ed0.md";